/**
 * @fileoverview Present calendar date/view navigation and delegate event creation to caller-owned actions. `kc-internal-frontend/src/components/Calendar/BespokeCalendar.js` owns selected view/date; shared calendar utilities supply labels. Navigation changes the browsing window rather than modifying stored events.
 */

import React, { useState, useEffect } from 'react';
import { CALENDAR_VIEWS, navigation } from '../utils/calendarUtils';



const CalendarNavigation = ({ 
  currentDate, 
  currentView, 
  onDateChange, 
  onViewChange,
  onAddEvent 
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize =

    () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const handlePrevious =

  () => {
    let newDate;
    switch (currentView) {
      case CALENDAR_VIEWS.MONTH_GRID:
      case CALENDAR_VIEWS.MONTH_AGENDA:
        newDate = navigation.previousMonth(currentDate);
        break;
      case CALENDAR_VIEWS.WEEK:
        newDate = navigation.previousWeek(currentDate);
        break;
      case CALENDAR_VIEWS.DAY:
        newDate = navigation.previousDay(currentDate);
        break;
      default:
        newDate = navigation.previousMonth(currentDate);
    }
    onDateChange(newDate);
  };

  const handleNext =

  () => {
    let newDate;
    switch (currentView) {
      case CALENDAR_VIEWS.MONTH_GRID:
      case CALENDAR_VIEWS.MONTH_AGENDA:
        newDate = navigation.nextMonth(currentDate);
        break;
      case CALENDAR_VIEWS.WEEK:
        newDate = navigation.nextWeek(currentDate);
        break;
      case CALENDAR_VIEWS.DAY:
        newDate = navigation.nextDay(currentDate);
        break;
      default:
        newDate = navigation.nextMonth(currentDate);
    }
    onDateChange(newDate);
  };

  const handleToday =

  () => {
    onDateChange(navigation.today());
  };

  const getNavigationLabel =

  () => {
    return navigation.getNavigationLabel(currentDate, currentView, isMobile);
  };

  const viewOptions = [
    { value: CALENDAR_VIEWS.MONTH_GRID, label: 'Month' },
    { value: CALENDAR_VIEWS.MONTH_AGENDA, label: 'Agenda' },
    { value: CALENDAR_VIEWS.WEEK, label: 'Week' },
    { value: CALENDAR_VIEWS.DAY, label: 'Day' }
  ];

  return (
    <div className="calendar-navigation">
      <div className="calendar-navigation-left">
        <button 
          className="nav-button today-button"
          onClick={handleToday}
        >
          Today
        </button>
        
        <div className="nav-controls">
          <button 
            className="nav-button nav-arrow"
            onClick={handlePrevious}
            aria-label="Previous"
          >
            &#8249;
          </button>
          
          <h2 className="nav-label">
            {getNavigationLabel()}
          </h2>
          
          <button 
            className="nav-button nav-arrow"
            onClick={handleNext}
            aria-label="Next"
          >
            &#8250;
          </button>
        </div>
      </div>

      <div className="calendar-navigation-right">
        <div className="view-switcher">
          {viewOptions.map(option => (
            <button
              key={option.value}
              className={`view-button ${currentView === option.value ? 'active' : ''}`}
              onClick={() => onViewChange(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
        
        <div className="nav-right-actions">
          <span 
            className="timezone-badge" 
            title={`Current time zone: ${Intl.DateTimeFormat().resolvedOptions().timeZone}`}
          >
            {Intl.DateTimeFormat().resolvedOptions().timeZone}
          </span>
          
          {onAddEvent && (
            <button 
              className="add-event-button"
              onClick={onAddEvent}
            >
              Add Event
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalendarNavigation; 